/// <reference path="../../../app.definition.ts" />

interface IEcvExpandingText {
    toggleExpanded($event: any): void;
    init(): void;
}

class EcvExpandingText implements IEcvExpandingText {
    expanded: boolean;
    expandCutoff: number;
    needsExpanding: boolean;
    text: string;
    shortText: string;
    preText: string;
    quotes: any;
    expandState: any;

    constructor() {
    }

    toggleExpanded($event: any): void {
        $event.preventDefault();
        $event.stopPropagation();
        this.expanded = !this.expanded;
        this.expandState = this.expanded;
    }

    init(): void {
        this.needsExpanding = this.text.length > this.expandCutoff;
        (this.expandState == undefined) ? this.expanded = false : this.expanded = this.expandState;
        //console.log('EcvExpandingText: ',this.needsExpanding ? 'Needs Expanding' : 'No expanding needed', 'Cutoff: ', this.expandCutoff, 'Text length: ', this.text.length);
        this.needsExpanding && (this.shortText = this.text.substring(0, this.expandCutoff));
        !!this.quotes && (this.quotes = true);
    }

}

function expandingText(): ng.IDirective {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: `
                <span class="expanding-text">
                    <span class="pre-text" ng-if="expandingTextVm.preText">{{expandingTextVm.preText}}</span>
                    <!-- span ng-if="!!expandingTextVm.quotes" class="quote">"</span-->
                    <div class="comment-wrapper">
                        <div ng-transclude class="comment-user"></div>
                        <div class="comment-text ecv-text-medium ecv-scrollbar">
                            <span ng-bind-html="expandingTextVm.needsExpanding && !expandingTextVm.expanded ? expandingTextVm.shortText + '...' : expandingTextVm.text | trustText"></span>
                        </div>
                        <div class="show-full-comment ecv-text-medium"><a ng-if="expandingTextVm.needsExpanding" ng-click="expandingTextVm.toggleExpanded($event)" class="show-more ecv-text-medium">
                                Show {{ expandingTextVm.expanded ? 'Less' : 'More' }}
                            </a></div>
                        <!--span ng-if="!!expandingTextVm.quotes" class="quote">"</span-->
                    </div>
                </span>
            `,
        controller: EcvExpandingText,
        controllerAs: 'expandingTextVm',
        bindToController: {
            'text': '=ecvText',
            'expandCutoff': '@ecvExpandCutoff',
            'preText': '@?preText',
            'quotes': '=?quotes',
            'expandState': '=?ecvExpandState'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvExpandingText): void => {
            controller.init();
        }
    };
}

angular.module('eCareVault.common.directives').directive('ecvExpandingText', expandingText);
